import Model from '~/models/Model';
import RouteEnum from '~/enums/RouteEnum';
import buildOnboardingFlow from '~/pages/employee/flows/onboarding/buildOnboardingFlow';

export default class Employee extends Model {
  resource() {
    return 'v1/employees';
  }

  hasOnboarded() {
    const flow = buildOnboardingFlow();

    return flow.completed({
      employee: this,
      // @ts-ignore
      organization: this.organization,
    });
  }

  getOnboardingRoute() {
    return RouteEnum.EMPLOYEE_ONBOARDING;
  }

  async statistics() {
    // @ts-ignore
    const endpoint = this.endpoint();

    const response = await this.request({
      method: 'GET',
      url: `${endpoint}/_statistics`,
    });

    return response?.data;
  }

  static statistics() {
    const self = new this();

    return self.statistics();
  }
}
